import { render, staticRenderFns } from "./Nick.vue?vue&type=template&id=a39713ca&"
import script from "./Nick.vue?vue&type=script&lang=js&"
export * from "./Nick.vue?vue&type=script&lang=js&"
import style0 from "./Nick.vue?vue&type=style&index=0&id=a39713ca&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports